import type { SourceRef } from "@/data/sources";
import { ReliabilityBadge } from "@/components/ReliabilityBadge";

/** Références et archives justifiant les faits et chiffres d'une rubrique. */
export function SourceList({
  sources,
  sourceKey,
}: {
  sources: SourceRef[];
  sourceKey?: string;
}) {
  if (!sources.length) return null;
  return (
    <section id="sources" className="mt-12 scroll-mt-24">
      <h2 className="border-b border-foreground pb-3 text-[0.65rem] uppercase tracking-[0.35em]">
        Sources et références
      </h2>
      <ReliabilityBadge sourceKey={sourceKey} className="mt-4" />
      <ul className="mt-4 space-y-3 text-[0.9rem] leading-relaxed text-muted-foreground">
        {sources.map((s) => (
          <li key={`${s.publisher}-${s.title}`}>
            <a
              href={s.url}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-foreground underline underline-offset-4 hover:no-underline"
            >
              {s.title}
            </a>
            {" — "}
            <span>{s.publisher}</span>
            {s.date ? <span> · {s.date}</span> : null}
          </li>
        ))}
      </ul>
      <p className="mt-4 text-xs text-muted-foreground">
        Les faits, dates et chiffres cités dans cette page s'appuient sur ces sources
        publiques. Une erreur ou une source manquante ?{" "}
        <a href="/contact" className="underline underline-offset-4">
          Signalez-la
        </a>
        .
      </p>
    </section>
  );
}
